// Chip — filter pill compacto con tono opcional. Similar a Badge pero con
// shape pill (rounded-full) y opcionalmente clickable.

import { forwardRef, type ButtonHTMLAttributes, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const chipVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors',
  {
    variants: {
      tone: {
        neutral: 'bg-surface-overlay text-fg-secondary',
        accent: 'bg-accent-soft text-accent border border-accent/30',
        ok: 'bg-ok-soft text-ok',
        warn: 'bg-warn-soft text-warn',
        crit: 'bg-crit-soft text-crit',
      },
      interactive: {
        true: 'cursor-pointer hover:bg-surface-elevated',
        false: '',
      },
    },
    defaultVariants: { tone: 'neutral', interactive: false },
  },
);

interface ChipProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof chipVariants> {}

export const Chip = forwardRef<HTMLSpanElement, ChipProps>(function Chip(
  { className, tone, interactive, ...props },
  ref,
) {
  return (
    <span ref={ref} className={cn(chipVariants({ tone, interactive }), className)} {...props} />
  );
});

interface ChipButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof chipVariants> {}

/** Versión Button del Chip — cuando el chip es interactive con onClick. */
export const ChipButton = forwardRef<HTMLButtonElement, ChipButtonProps>(function ChipButton(
  { className, tone, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(chipVariants({ tone, interactive: true }), className)}
      {...props}
    />
  );
});
